import { CheckCircle2, Circle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";

interface Course {
  day: number;
  theme: string;
  completed: boolean;
}

interface ProgressTrackerProps {
  courses: Course[];
  currentDay: number;
  onDaySelect: (day: number) => void;
}

export const ProgressTracker = ({ courses, currentDay, onDaySelect }: ProgressTrackerProps) => {
  const completedCount = courses.filter(c => c.completed).length;
  const progressPercentage = (completedCount / courses.length) * 100;

  return (
    <Card className="shadow-[var(--shadow-medium)]">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle>学习进度</CardTitle>
          <Badge variant="secondary">
            {completedCount}/{courses.length} 天
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">总体进度</span>
            <span className="font-medium">{Math.round(progressPercentage)}%</span>
          </div>
          <Progress value={progressPercentage} className="h-2" />
        </div>

        <div className="grid grid-cols-7 gap-2">
          {courses.map((course) => (
            <button
              key={course.day}
              onClick={() => onDaySelect(course.day)}
              className={`relative aspect-square rounded-lg border-2 transition-all hover:scale-105 ${
                course.day === currentDay
                  ? 'border-primary bg-primary/10'
                  : course.completed
                  ? 'border-green-500 bg-green-50 dark:bg-green-950'
                  : 'border-border'
              }`}
              title={`第${course.day}天: ${course.theme}`}
            >
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                {course.completed ? (
                  <CheckCircle2 className="h-4 w-4 text-green-500 mb-1" />
                ) : (
                  <Circle className="h-4 w-4 text-muted-foreground mb-1" />
                )}
                <span className="text-xs font-medium">{course.day}</span>
              </div>
            </button>
          ))}
        </div>

        <div className="text-xs text-muted-foreground text-center pt-2 border-t">
          点击日期查看对应课程
        </div>
      </CardContent>
    </Card>
  );
};
